export default __webpack_public_path__ + "static/media/doctor_selected.f1ba1944.svg";